// extracted by mini-css-extract-plugin
export default {"tableFooter":"TableFooter_tableFooter__lcStZ"};